import api from "./axios";

const BASE = "/vehicle-photos";

export const listVehiclePhotos = (params = {}) =>
  api.get(BASE, { params });

export const getVehiclePhotosByRider = (riderId) =>
  api.get(`${BASE}/${riderId}`);

export const downloadVehiclePhoto = (riderId, slot) =>
  api.get(`${BASE}/${riderId}/file/${slot}`, { responseType: "blob" });
